var Layout        = require("./VideoGraphicLayout"),
    config        = require("app/config"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get,
    kind          = require("enyo/kind");

require("./VideoGraphic.less");

module.exports = kind(/** @lends  app.ui.HeaderGraphic.VideoGraphic.prototype */ {

    /**
     * @private
     */
    name: "app.ui.HeaderGraphic.VideoGraphic",

    /**
     * @private
     */
    classes: "app-ui-header-graphic-video-graphic",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * Layout metrics tell us how to scale the video.
     *
     * @type {Object}
     * @readonly
     * @public
     */
    layoutMetrics: null,

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:       "video",
        tag:        "video",
        attributes: {
            "x-webkit-airplay":    "deny",
            autoplay:              true,
            controls:              false,
            disableRemotePlayback: true,
            loading:               "lazy",
            loop:                  true,
            muted:                 true,
            playsinline:           true,
            src:                   this.videoSource
        },
        classes: "app-ui-header-graphic-video-graphic__video"
    }, {
        name:    "topGradient",
        classes: "app-ui-header-graphic-video-graphic__top-gradient"
    }, {
        name:    "leftGradient",
        classes: "app-ui-header-graphic-video-graphic__left-gradient"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state       = this.state || {},
            videoSource = get(state, "data.preview_url", null),
            videoCdn    = get(config, "previewUrlPrefix", "");

        this.$.leftGradient.set("showing", get(state, "data.show_meta_text", false));

        if (typeof videoSource === "string"
            && videoSource.substring(0, 4) !== "http") {
            videoCdn    = videoCdn.replace(/\/+$/, "");
            videoSource = videoSource.replace(/^\/+/, "");
            videoSource = videoCdn + "/" + videoSource;
        }
        this.$.video.setAttribute("src", videoSource);
    }

});
